const images = {
  Splash: require('./splash.png'),
  AlternativeLogo: require('./alternative-logo.png'),
};

export { images };
